import React from "react";
import { connect } from "react-redux";
import { ActivityDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { AlertControl } from "components/Modals/Alert";
import moment from "moment";
import { Displays, Forms, Modals } from "components";

class ActivityDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    scrollToTopPageFN();
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      this.props.router.params.id === "create"
        ? true
        : portalService.GET_ACTIVITY_DETAIL(this.props.router.params.id),
      portalService.GET_BUSINESS_UNIT_LIST(`?pagination=false&is_delete=false`),
    ]);
    if (resArr) {
      if (this.props.router.params.id === "create") {
        this.setState({
          businessUnitOptions: [
            { label: "None", value: "null" },
            ...resArr[1].data.docs.map((e) => ({
              label: e.name,
              value: e._id,
            })),
          ],
          isLoading: false,
          isBgLoading: false,
        });
      } else {
        // กิจกรรมจองที่นั่งเปิดจองได้เมื่อ Active + ช่วงลงทะเบียน + ตั้งค่าที่หน้า Booking Seat ครบ
        // ดึงสถานะมาโชว์ แอดมินจะได้ไม่งงว่าเปิด Active แล้วทำไมลูกค้ายังจองไม่ได้
        let resSeat =
          resArr[0].data && resArr[0].data.is_seat_booking
            ? await portalService.GET_SEAT_BOOKING_CONFIG(this.props.router.params.id)
            : false;
        this.setState({
          seatStatus: resSeat && resSeat.status === 200 ? resSeat.data : false,
          initialValues: resArr[0].data,
          businessUnitOptions: [
            { label: "None", value: "null" },
            ...resArr[1].data.docs.map((e) => ({
              label: e.name,
              value: e._id,
            })),
          ],
          isLoading: false,
          isBgLoading: false,
        });
      }
    }
  };

  // FLOW DELETE
  // =============================
  // =============================
  handleDelete = () => {
    this.setState({
      renderModal: (
        <Displays.CofirmBox
          label="คุณต้องการลบใช่หรือไม่ ?"
          labelBtn1="Confirm"
          labelBtn2="Cancel"
          onAction1={this.deleteAction}
          onAction2={this.handleCloseModal}
        />
      ),
    });
  };
  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_ACTIVITY_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      toast.success("ลบสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("ลบไม่สำรเร็จ");
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    const { questionDelete } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let tempValue = { ...values };
    let params = {
      ...tempValue,
      business_unit_ref_id:
        tempValue.business_unit_ref_id === "null"
          ? null
          : tempValue.business_unit_ref_id,
      question_list: tempValue.question_list.map((e) => ({
        ...e,
        image: [],
      })),
    };
    if (values.registration_start_time) {
      params.registration_start_time = moment(
        values.registration_start_time
      ).format("HH:mm");
    }
    if (values.registration_end_time) {
      params.registration_end_time =
        moment(values.registration_end_time).format("HH:mm") + ":59";
    }
    let res =
      this.props.router.params.id === "create"
        ? await portalService.POST_ACTIVITY_DETAIL(params)
        : await portalService.PUT_ACTIVITY_UPDATE(
            this.props.router.params.id,
            params
          );
    if (res && res.status === 200) {
      let filesTemp = [];
      const mediaCondition = (file) => {
        const reduce = file.reduce(
          (result, data) => {
            if (data.isNewUpload) {
              result.isNewUpload = true;
              result.fileNewUpload = data;
            }
            if (data.isDelete) {
              result.isDelete = true;
              result.fileDeleteUpload = data;
            }
            return result;
          },
          {
            isNewUpload: false,
            isDelete: false,
            fileNewUpload: false,
            fileDeleteUpload: false,
          }
        );
        if (reduce.isNewUpload && reduce.isDelete) {
          return [reduce.fileNewUpload];
        } else {
          if (reduce.isNewUpload) {
            return [reduce.fileNewUpload];
          } else {
            if (reduce.isDelete) {
              return [reduce.fileDeleteUpload];
            } else {
              return [];
            }
          }
        }
      };
      if (values.img_file || values.img_file2) {
        filesTemp = [
          ...filesTemp,
          ...mediaCondition(values.img_file),
          ...mediaCondition(values.img_file2),
        ];
      }
      if (filesTemp.length === 0) {
        let renderParamMedia = [];
        if (values.question_list) {
          renderParamMedia = values.question_list.reduce((result, data, i) => {
            if (data.image && data.image.length > 0) {
              if (data.image.length === 1) {
                if (data.image[0].isNewUpload) {
                  result.push({
                    ...data,
                    question_id: res.data.question_list[i]._id,
                  });
                }
              } else {
                data.image.forEach((f) => {
                  if (f.isNewUpload) {
                    result.push({
                      ...data,
                      image: [f],
                      question_id: res.data.question_list[i]._id,
                    });
                  }
                  if (f.media_uri) {
                    result.push({
                      img_path: f.media_uri,
                      isDelete: true,
                      question_id: res.data.question_list[i]._id,
                    });
                  }
                });
              }
            }
            return result;
          }, []);
        }
        if (questionDelete) {
          renderParamMedia = [...renderParamMedia, ...questionDelete];
        }
        if (renderParamMedia && renderParamMedia.length > 0) {
          this.handleUploadContentMediaQuestion(res.data._id, renderParamMedia);
        } else {
          toast.success("อัพเดตสำเร็จ");
          this.handleNextStep();
        }
      } else {
        let renderParamMedia = [];
        if (values.question_list) {
          renderParamMedia = values.question_list.reduce((result, data, i) => {
            if (data.image && data.image.length > 0) {
              if (data.image.length === 1) {
                if (data.image[0].isNewUpload) {
                  result.push({
                    ...data,
                    question_id: res.data.question_list[i]._id,
                  });
                }
              } else {
                data.image.forEach((f) => {
                  if (f.isNewUpload) {
                    result.push({
                      ...data,
                      image: [f],
                      question_id: res.data.question_list[i]._id,
                    });
                  }
                  if (f.media_uri) {
                    result.push({
                      img_path: f.media_uri,
                      isDelete: true,
                      question_id: res.data.question_list[i]._id,
                    });
                  }
                });
              }
            }
            return result;
          }, []);
        }
        if (questionDelete) {
          renderParamMedia = [...renderParamMedia, ...questionDelete];
        }
        this.handleUploadContentMedia(
          res.data._id,
          filesTemp,
          renderParamMedia
        );
      }
    } else {
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };
  handleUploadContentMedia = (activityID, files, questionList) => {
    Promise.all(
      files.map((e) => {
        return new Promise(async (resolve) => {
          if (e.isNewUpload) {
            const bodyFormData = new FormData();
            bodyFormData.set("activity_id", activityID);
            bodyFormData.append("image", e);
            bodyFormData.append("type", e.fieldName);
            let res = await portalService.POST_ACTIVITY_UPLOAD(bodyFormData);
            if (res && res.status === 200) {
              resolve();
            }
          }
          if (e.isDelete) {
            let res = await portalService.POST_ACTIVITY_UPLOAD_DELETE({
              activity_id: activityID,
              field_name: e.fieldName,
              path_name: e.media_uri,
            });
            if (res && res.status === 200) {
              resolve();
            }
          }
        });
      })
    ).then(() => {
      if (questionList && questionList.length > 0) {
        this.handleUploadContentMediaQuestion(activityID, questionList);
      } else {
        this.setState({
          isBgLoading: false,
        });
        toast.success("อัพเดจสำเร็จ");
        this.handleNextStep();
      }
    });
  };

  handleUploadContentMediaQuestion = (activityID, files) => {
    Promise.all(
      files.map((e, i) => {
        return new Promise(async (resolve) => {
          const bodyFormData = new FormData();
          bodyFormData.set("activity_id", activityID);
          bodyFormData.set("question", e.question);
          bodyFormData.set("type", e.type);
          if (e.question_id) {
            bodyFormData.append("question_id", e.question_id);
          }
          if (e.answer_list) {
            bodyFormData.append("answer_list", e.answer_list);
          }
          if (e.image && e.image.length > 0) {
            bodyFormData.append("image", e.image[0]);
          }
          let res = !e.isDelete
            ? await portalService.POST_ACTIVITY_QUESTION_UPLOAD(bodyFormData)
            : await portalService.POST_ACTIVITY_QUESTION_MEDIA_DELETE({
                img_path: e.img_path,
              });
          if (res && res.status === 200) {
            resolve();
          }
        });
      })
    ).then(() => {
      this.setState({
        isBgLoading: false,
      });
      toast.success("อัพเดจสำเร็จ");
      this.handleNextStep();
    });
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  handleSent = async () => {
    AlertControl.show({
      title: "ยืนยันการส่ง",
      description: "คุณต้องการจะส่งแจ้งเตือนใช่หรือไม่",
      btnLabel1: "ยกเลิก",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        const { initialValues } = this.state;
        this.setState({
          isBgLoading: true,
        });
        let paramsPopup = {
          feature_id: initialValues._id,
          img_path: initialValues.img,
          feature_type: "2",
        };
        let paramsNoti = {
          feature_id: initialValues._id,
          title: initialValues.name,
          message: initialValues.description,
          feature_type: "2",
        };
        let res = await Promise.all([
          portalService.POST_POPUP_SENT(paramsPopup),
          portalService.POST_NOTIFICATION_SENT(paramsNoti),
          portalService.PUT_ACTIVITY_UPDATE(this.props.router.params.id, {
            is_popup_activate: true,
            is_notification_activate: true,
          }),
        ]);
        if (res) {
          this.fetchData();
        }
      },
    });
  };

  handleDeleteQuestion = (e) => {
    const { initialValues, questionDelete } = this.state;
    if (
      this.props.router.params.id !== "create" &&
      e.image &&
      e.image.length > 0 &&
      e.image[0].media_uri
    ) {
      let find = initialValues.question_list.find((f) => f._id === e._id);
      if (find) {
        if (!questionDelete) {
          this.setState({
            questionDelete: [{ ...e, isDelete: true }],
          });
        } else {
          let temp = questionDelete;
          temp.push({ ...e, isDelete: true });
          this.setState({
            questionDelete: [{ ...temp }],
          });
        }
      }
    }
  };

  handleNextStep = () => {
    this.props.router.navigate(ROUTE_PATH.ACTIVITY);
  };

  // DUPLICATE FORM
  // ===================================
  // ===================================
  handleDuplicate = async () => {
    this.setState({ isBgLoading: true });
    let res = await portalService.GET_ACTIVITY_LIST(`?pagination=false`);
    if (res && res.status === 200) {
      const optionstemp = res.data.docs.map((e) => ({
        label: e.short_title_th,
        value: e._id,
      }));
      this.setState({
        activityData: res.data.docs,
        activityOptions: optionstemp,
        renderModal: (
          <Forms.ActivityDuplicateForm
            options={optionstemp}
            onCancel={this.handleCloseModal}
            onSubmit={this.handleSelectDuplicate}
          />
        ),
        isBgLoading: false,
      });
    }
  };
  handleSelectDuplicate = (values) => {
    const { activityData } = this.state;
    const findData = activityData.find(
      (e) => String(e._id) === String(values.activity.value)
    );
    if (!findData) {
      this.setState({
        renderModal: false,
      });
      toast.error("ไม่พบข้อมูลของท่าน");
    } else {
      let params = {
        ...findData,
      };
      delete params._id;
      delete params.created_at;
      delete params.updated_at;
      delete params.code;
      delete params.permission_main_active;
      delete params.permission_reserve_active;
      delete params.img;
      delete params.img2;
      delete params.qrcode_list;
      delete params.is_edit;
      delete params.is_popup_activate;
      delete params.is_notification_activate;
      delete params.status;
      delete params.is_join;
      delete params.join_ref_id;
      // ผังที่นั่ง/ราคา/การจองอยู่นอกตัวกิจกรรม duplicate แล้วไม่ตามไป จึงไม่ copy flag จองที่นั่ง
      delete params.is_seat_booking;
      delete params.is_unlisted;
      if (findData.question_list) {
        params.question_list = findData.question_list.map((e) => {
          let temp = { ...e };
          delete temp._id;
          delete temp.img_path;
          return temp;
        });
      }
      this.setState({
        initialValues: params,
        renderModal: false,
      });
    }
  };

  handlePreview = (values) => {
    // this.setState({
    //   renderModal: (
    //     <ActivityPreviewWidget
    //       data={values}
    //       onBack={this.handleCloseModal}
    //       onClose={this.handleCloseModal}
    //     />
    //   ),
    // });
  };

  // สถานะคิดจากข้อมูลที่บันทึกแล้ว (server ตัดสินตัวเดียวกับฝั่งลูกค้า) แสดงเป็นแถวหนึ่งในฟอร์ม
  buildSeatStatus = (seatStatus) => {
    const { initialValues } = this.state;
    const dateText = (value) => (value ? moment(value).format("DD/MM/YYYY HH:mm") : "-");
    const gateProblems = seatStatus.gate_problems || [];
    const checks = [
      initialValues && initialValues.is_active
        ? { ok: true, label: "เปิด Active แล้ว" }
        : { ok: false, label: "ยังไม่เปิด Active" },
      seatStatus.registration_state === "before"
        ? { ok: false, label: `ยังไม่ถึงช่วงลงทะเบียน (เปิด ${dateText(seatStatus.registration_opens_at)})` }
        : seatStatus.registration_state === "after"
        ? { ok: false, label: `หมดช่วงลงทะเบียนแล้ว (ปิด ${dateText(seatStatus.registration_closes_at)})` }
        : {
            ok: true,
            label: `อยู่ในช่วงลงทะเบียน (${dateText(seatStatus.registration_opens_at)} - ${dateText(
              seatStatus.registration_closes_at
            )})`,
          },
      ...(gateProblems.length
        ? gateProblems.map((p) => ({ ok: false, label: p }))
        : [{ ok: true, label: "ตั้งค่าผังที่นั่ง ราคา และบัญชีรับโอนครบแล้ว" }]),
    ];
    return { isOpen: !seatStatus.closed_reason, checks };
  };

  handleGoSeatSetting = () => {
    const { router } = this.props;
    router.navigate(`${ROUTE_PATH.ACTIVITY}/seat/${router.params.id}?tab=setting`);
  };

  render() {
    const { authenRedux, router } = this.props;
    const {
      isLoading,
      initialValues,
      isBgLoading,
      businessUnitOptions,
      renderModal,
      seatStatus,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "activity");
    return (
      <ActivityDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading theme_standard_loading />
          </div>
        ) : (
          <Forms.ActivityForm
            id={router.params.id}
            initialValues={initialValues}
            businessUnitOptions={businessUnitOptions}
            permission={permission}
            onCancel={this.handleCancel}
            onDelete={this.handleDelete}
            onDeleteQuestion={this.handleDeleteQuestion}
            onSent={this.handleSent}
            onSubmit={this.handleSubmit}
            onDuplicate={this.handleDuplicate}
            onPreview={this.handlePreview}
            seatStatus={seatStatus ? this.buildSeatStatus(seatStatus) : false}
            onGoSeatSetting={this.handleGoSeatSetting}
          />
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </ActivityDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ActivityDetailContainer));
